import React, { CSSProperties } from "react";
import { IETableState } from "./Interfaces";
import { El } from "./index";

class EImg extends El<HTMLImageElement, IETableState> {
    getStyles = (): CSSProperties => {
        let styles: CSSProperties = {
            backgroundColor: "transparent",
        };

        if (this.props.Brand) {
            const { Brand, width, height } = this.props;

            styles = {
                width: width,
                height: height,
                border: 0,
                display: "block",
                backgroundColor: "transparent",
                color: Brand.fontColor,
                fontFamily: Brand.fontFamily,
                fontSize: Brand.documentFontSize,
            };
        }

        if (this.props.width) {
            styles.width = this.props.width;
        }

        if (this.props.height) {
            styles.height = this.props.height;
        }

        return styles;
    };

    render(): JSX.Element {
        const { Brand, ...rest } = this.props;
        return (
            //@ts-ignore  depricated html attributes
            <img
                border="0"
                style={this.__setStyle(this.getStyles())}
                {...rest}
            />
        );
    }
}

export { EImg };
